



























































import {Component, Prop, Mixins, Watch} from 'vue-property-decorator'
import Assets from '@/mixins/Assets'

@Component
export default class FlightPaperPlaneWithConfetti extends Mixins(Assets) {
  @Prop({default: false, type: Boolean}) show: boolean

  paperplaneClass: string = ''
  planeLoaded: boolean = false
  confettiLoaded: boolean = false

  @Watch('show', {immediate: true})
  __show() {
    this.$nextTick(() => {
      this.paperplaneClass = ''
    })
  }

  stopThePlane() {
    this.paperplaneClass = 'paperplane-center'
  }

  get fly() {
    return this.planeLoaded && this.confettiLoaded
  }

  loadPlane() {
    this.planeLoaded = true
  }

  loadConfetti() {
    this.confettiLoaded = true
  }
}
